// Premium SVG sport icons — replaces emoji across all Sports pages

const icons = {
  pickleball: ({ color, size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Rectangular paddle head — distinctly NOT a round ping-pong paddle */}
      <rect x="5.5" y="2" width="13" height="15" rx="3.5" stroke={color} strokeWidth="1.9"/>
      {/* Perforated holes — characteristic of pickleball */}
      <circle cx="10" cy="6.5" r="1.2" fill={color}/>
      <circle cx="14" cy="6.5" r="1.2" fill={color}/>
      <circle cx="10" cy="11" r="1.2" fill={color}/>
      <circle cx="14" cy="11" r="1.2" fill={color}/>
      <circle cx="12" cy="14.5" r="0.9" fill={color} opacity="0.55"/>
      {/* Short handle */}
      <rect x="10.5" y="17" width="3" height="5.5" rx="1.5" fill={color}/>
    </svg>
  ),

  tennis: ({ color, size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Oval racket head */}
      <ellipse cx="12" cy="9.5" rx="7" ry="8.5" stroke={color} strokeWidth="1.9"/>
      {/* String grid lines */}
      <line x1="6" y1="7" x2="18" y2="7" stroke={color} strokeWidth="0.9" opacity="0.6"/>
      <line x1="5.5" y1="11" x2="18.5" y2="11" stroke={color} strokeWidth="0.9" opacity="0.6"/>
      <line x1="10" y1="1.5" x2="10" y2="17.5" stroke={color} strokeWidth="0.9" opacity="0.6"/>
      <line x1="14" y1="1.5" x2="14" y2="17.5" stroke={color} strokeWidth="0.9" opacity="0.6"/>
      {/* Handle */}
      <rect x="10.5" y="18" width="3" height="5.5" rx="1.5" fill={color}/>
    </svg>
  ),

  badminton: ({ color, size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Shuttlecock cork at bottom */}
      <ellipse cx="12" cy="20" rx="2.5" ry="2" fill={color} opacity="0.85"/>
      {/* Feather skirt widening upward */}
      <path d="M9.5 18 L6 7 M14.5 18 L18 7" stroke={color} strokeWidth="1.6" strokeLinecap="round"/>
      <path d="M9.5 18 L8 7 M14.5 18 L16 7" stroke={color} strokeWidth="1" strokeLinecap="round" opacity="0.6"/>
      {/* Crown of feathers */}
      <ellipse cx="12" cy="6.5" rx="6" ry="2.5" stroke={color} strokeWidth="1.8"/>
    </svg>
  ),

  basketball: ({ color, size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9.5" stroke={color} strokeWidth="1.9"/>
      {/* Classic ball seam arcs */}
      <path d="M12 2.5 Q16.5 12 12 21.5" stroke={color} strokeWidth="1.5" fill="none"/>
      <path d="M12 2.5 Q7.5 12 12 21.5" stroke={color} strokeWidth="1.5" fill="none"/>
      <line x1="2.5" y1="12" x2="21.5" y2="12" stroke={color} strokeWidth="1.5"/>
    </svg>
  ),

  volleyball: ({ color, size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9.5" stroke={color} strokeWidth="1.9"/>
      {/* Curved panel seams */}
      <path d="M4.5 7.5 Q12 13.5 19.5 7.5" stroke={color} strokeWidth="1.5" fill="none"/>
      <path d="M4.5 16.5 Q12 10.5 19.5 16.5" stroke={color} strokeWidth="1.5" fill="none"/>
      <line x1="12" y1="2.5" x2="12" y2="21.5" stroke={color} strokeWidth="1.5"/>
    </svg>
  ),

  futsal: ({ color, size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9.5" stroke={color} strokeWidth="1.9"/>
      {/* Soccer ball pentagon pattern */}
      <polygon points="12,5.5 15.5,8.5 14.2,13 9.8,13 8.5,8.5" stroke={color} strokeWidth="1.6" fill={color} fillOpacity="0.18"/>
      <line x1="15.5" y1="8.5" x2="21" y2="7.5" stroke={color} strokeWidth="1" opacity="0.5"/>
      <line x1="8.5" y1="8.5" x2="3" y2="7.5" stroke={color} strokeWidth="1" opacity="0.5"/>
      <line x1="14.2" y1="13" x2="17.5" y2="19" stroke={color} strokeWidth="1" opacity="0.5"/>
      <line x1="9.8" y1="13" x2="6.5" y2="19" stroke={color} strokeWidth="1" opacity="0.5"/>
      <line x1="12" y1="5.5" x2="12" y2="2.5" stroke={color} strokeWidth="1" opacity="0.5"/>
    </svg>
  ),

  other: ({ color, size }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      {/* Generic top-down court view */}
      <rect x="2" y="4.5" width="20" height="15" rx="1.5" stroke={color} strokeWidth="1.9"/>
      <line x1="12" y1="4.5" x2="12" y2="19.5" stroke={color} strokeWidth="1.5"/>
      <circle cx="12" cy="12" r="3.5" stroke={color} strokeWidth="1.2"/>
      <line x1="2" y1="9.5" x2="5" y2="9.5" stroke={color} strokeWidth="1.2"/>
      <line x1="2" y1="14.5" x2="5" y2="14.5" stroke={color} strokeWidth="1.2"/>
      <line x1="19" y1="9.5" x2="22" y2="9.5" stroke={color} strokeWidth="1.2"/>
      <line x1="19" y1="14.5" x2="22" y2="14.5" stroke={color} strokeWidth="1.2"/>
    </svg>
  ),
};

export function SportIcon({ sport = 'other', size = 24, color = 'currentColor' }) {
  const key = sport?.toLowerCase();
  const Icon = icons[key] || icons.other;
  return <Icon color={color} size={size} />;
}

export const SPORT_COLORS = {
  pickleball: '#FF6D00',
  tennis:     '#00E676',
  badminton:  '#2979FF',
  basketball: '#FFB300',
  volleyball: '#B429FF',
  futsal:     '#00BCD4',
  other:      '#A3A3A3',
};
